<script setup lang="ts">
import type { Component } from 'vue'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { setTitle } from '~/utils/dom'
import { useAuthStore } from '~/stores/auth'
import { GradeType } from '~/models/GradeType'
import HomeVgs from '~/components/home/homeVgs/HomeVgs.vue'
import HomePrep from '~/components/home/homePrep/HomePrep.vue'
import HomeAdult from '~/components/home/homeAdult/HomeAdult.vue'
import Home8To10 from '~/components/home/home8to10/Home8To10.vue'
import Home5To7 from '~/components/home/home5to7/Home5To7.vue'
import Home1To4 from '~/components/home/home1to4/Home1To4.vue'
import DefaultHome from '~/components/home/DefaultHome.vue'

const { t } = useI18n()
const { selectedGradeType } = storeToRefs(useAuthStore())

setTitle(t('home.title'))

const componentMap = new Map<GradeType, Component>([
  [GradeType.Grade1To4, Home1To4],
  [GradeType.Grade5To7, Home5To7],
  [GradeType.Grade8To10, Home8To10],
  [GradeType.GradeVgs, HomeVgs],
  [GradeType.GradeAdult, HomeAdult],
  [GradeType.GradePrep, HomePrep],
])

const componentToRender = computed(() => selectedGradeType.value
  ? componentMap.get(selectedGradeType.value) || DefaultHome
  : DefaultHome)
</script>

<template>
  <component :is="componentToRender" />
</template>
